<template>
  <div class="system">
    <banner clazz="system-banner" url="system" hasDivider>
      <template slot="buttons">
        <el-button class="banner-button" round @click="goMore('neibujicheng-banner-tiyan')">申请体验</el-button>
        <el-button class="banner-button" round @click="this.goConsult">立即咨询</el-button>
      </template>
    </banner>

    <div class="system-section1">
      <div class="container">
        <div class="section1-content">
          <img class="section1-img" src="../../assets/img/system/peitu.png" alt="内部系统集成"/>
          <div class="section1-misc">
            <div class="misc-title">
              <p>内部系统集成</p>
            </div>
            <div class="misc-divider"></div>
            <p class="misc-content">甄云SRM提供开放的接口平台，旨在集成企业ERP系统、OA/BPM等内部管理系统。主流ERP系统如SAP、Oracle ERP、用友、金蝶等均提供通用接口，数百家客户成功实施验证。开放接口平台将原本分散在各系统的采购数据传输整合，按需分配，有效消除部门间，企业与上有供应商的信息孤岛。降低生产成本，扩大经济效益。</p>
            <hover-button clazz="consult-button" text="立即咨询" @click.native="goConsult"></hover-button>
          </div>
        </div>
      </div>
    </div>

    <div class="system-section2">
      <div class="item-list">
        <div class="tc">
          <h1 class="item-list-title">内部系统集成平台特色</h1>
          <div class="dib tl border-bottom"></div>
        </div>
        <div class="item-tab">
          <el-tabs type="border-card" stretch>
            <el-tab-pane label="统一入口">
              <div class="rel clearfix content">
                <div class="fl left-list">
                  <h2 class="title">统一入口</h2>
                  <div class="border-bottom-tab"></div>
                  <p class="left-desc">
                    通过甄云SRM采购管理平台为用户提供统一的信息系统登录入口，可以直接进入其它信息系统，不必再输入用户名/密码，很大程度上为企业用户登录各项信息系统提供了方便。同时为企业建立了一个统一的协同工作平台。
                  </p>
                </div>
                <div class="fr rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/system/peitu1.png" alt="统一入口">
                  </div>
                  <div class="abs right-bg rbg01"></div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="信息交互">
              <div class="clearfix content">
                <div class="fl left-list">
                  <h2 class="title">信息交互</h2>
                  <div class="border-bottom-tab"></div>
                  <p class="left-desc">
                    通过甄云集成平台，将其它系统的部分信息数据引用、推送到甄云SRM，方便采购员及时查阅和处理。 例如：送发货信息、未读邮件、数据报表、费用支付等各类信息。这些集成应用将原本分散的数据信息传输整合，按需分配，有效消除企业信息孤岛。
                  </p>
                </div>
                <div class="fr rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/system/peitu2.png" alt="信息交互">
                  </div>
                  <div class="abs right-bg rbg02"></div>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="资源整合">
              <div class="clearfix content">
                <div class="fl left-list">
                  <h2 class="title">资源整合</h2>
                  <div class="border-bottom-tab"></div>
                  <p class="left-desc">
                    内部系统的集成，便于知晓社会竞争态势，比对供应商发货时间和速度优劣来实现企业资源重组优化，很大程度上改善了传统企业采购资金、物流、信息运转较慢的状况，去除了中间不必要的繁杂环节，降低了企业采购成本，并在一定程度上提升了企业面对突发状况的应变能力。
                  </p>
                </div>
                <div class="fr rel right-list">
                  <div class="right-img">
                    <img src="../../assets/img/system/peitu3.png" alt="资源整合">
                  </div>
                  <div class="abs right-bg rbg03"></div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="item-list2"></div>
    </div>
  </div>
</template>

<script>
import hoverButton from '../common/hoverButton.vue'
import banner from '../common/banner.vue'
export default {
  inject: ['openRegister', 'goConsult'],
  name: 'System',
  metaInfo () {
    return {
      title: this.$seo.system.title, // set a title
      meta: [{ // set meta
        name: 'keywords',
        content: this.$seo.system.keywords
      },
      {
        name: 'description',
        content: this.$seo.system.description
      }]
    }
  },
  components: {
    hoverButton,
    banner
  },
  data () {
    return {
    }
  },
  methods: {
    goMore (code) {
      this.openRegister(false, code)
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss">
  @import "../../../static/css/system.scss";
</style>



// WEBPACK FOOTER //
// system.vue?708a04e7